import type { FiltersItemInterface } from '../contracts/filters.interface';

export interface FilterItemOption extends FiltersItemInterface {
	disabled: boolean;
}

/**
 * An item without results can only be deselected, never selected: it is
 * disabled unless it is active. The BFF recalculates the frequencies for the
 * active filters, so selecting an enabled item never ends in zero results.
 */
export function withAvailability(
	items: FiltersItemInterface[],
	activeValues: readonly string[],
): FilterItemOption[] {
	return items.map((item) => ({
		...item,
		disabled: item.frequency === 0 && !activeValues.includes(item.value),
	}));
}
